// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-tabbar[data-v-fcca4262]{height:56px;border-top:1px solid #eceef2;box-sizing:content-box}.aroma-tabbar[data-v-fcca4262] .van-tabbar-item{min-width:64px;min-height:56px;font-size:12px;touch-action:manipulation}.aroma-tabbar[data-v-fcca4262] .van-tabbar-item__icon{margin-bottom:3px;font-size:23px}", ""]);
// Exports
module.exports = exports;
